// extracted by mini-css-extract-plugin
module.exports = {"paginator":"Paginator_paginator__a9gOE","pageNumber":"Paginator_pageNumber__3XEPH","selectedPage":"Paginator_selectedPage__3m0Sy"};